module.exports = __webpack_public_path__ + "img/8.ea568fc0.png";